import React, {useState} from 'react'
import {makeStyles} from '@mui/styles';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import {Button, CardHeader, Chip, Collapse, Icon, IconButton, Typography} from '@mui/material';
import {AccessTime, BookmarkBorder, ChatBubbleOutline, ExpandMore, FavoriteBorder, Kitchen, Visibility, AddShoppingCart, RemoveShoppingCart} from '@mui/icons-material';


const useStyles = makeStyles(theme => ({
    card: {
        maxWidth: 450,
        width: "100%",
        minWidth: "250px",
        height: "auto",
        marginTop: "1vh",
        marginBottom: "1vh",
        borderRadius: 0,
    },

    CardContent: {
        display: 'flex',
        height: "500px",
        paddingTop: '1vh',
        paddingBottom: '1vh',
        paddingLeft: '5vw',
        paddingRight: '5vw'
    },
    media: {
        position: 'relative',
        width: "100%",
        height: 0,
        paddingTop: "100%",
    },
    mediaDetails: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        gap: 8,
        background: '#f5f5f5',
        padding: '2px 8px',
    },
    mediaDetail: {
        minWidth: 35,
        textAlign: 'center',
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    },
    mediaDetailText: {},
    Content: {
        flex: 1,
        flexDirection: 'column',
        display: 'flex',
    },
    title: {
        maxHeight:"4em",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        "-webkitLineClamp": 2,
        "-webkitBoxOrient": "vertical"
    }

}));

export default function PresentableRecipeCardSmall({
                                                       commands,
                                                       recipe,
                                                       basketClick,
                                                       userClick,
                                                       recipeClick,
                                                       chipClick,
                                                       update,
                                                       inBasket
                                                   }) {
    const classes = useStyles();
    const {recipeName, timeInMinutes, imageData, ingredients, views, labels, about} = recipe
    const [expanded, setExpanded] = useState(false);

    function formatTime(minutes) {
        if (minutes >= 60) {
            const h = Math.floor(minutes / 60);
            const m = minutes % 60;
            return m > 0 ? `${h}h${m}m` : `${h}h`;
        }
        return `${minutes}m`;
    }
    return (
        <Card variant="outlined" className={classes.card}>
            <div onClick={recipeClick} style={{cursor: 'pointer'}}>
                <CardHeader
                    style={{paddingLeft: 8, paddingTop: 6, paddingBottom: 4}}
                    titleTypographyProps={{variant: "body1", className: classes.title}}
                    title={recipeName ? recipeName.charAt(0).toUpperCase() + recipeName.slice(1).toLowerCase() : ''}
                    action={
                        <IconButton size="small" onClick={(e) => { e.stopPropagation(); basketClick(); }}>
                            {inBasket ? <RemoveShoppingCart color="secondary"/> : <AddShoppingCart color="secondary"/>}
                        </IconButton>
                    }
                />
                <CardMedia
                    className={classes.media}
                    image={imageData ? imageData : process.env.PUBLIC_URL+"/notFoundImage.svg"}
                    style={imageData ? {} : {backgroundSize: "50%"}}
                    title={recipeName ? recipeName.charAt(0).toUpperCase() + recipeName.slice(1).toLowerCase() : ''}
                >
                    <div className={classes.mediaDetails}>
                        <div className={classes.mediaDetail} style={{marginLeft: -4}}>
                            <Icon color="secondary" style={{overflow: 'visible'}}>
                                <AccessTime/>
                            </Icon>
                            <Typography variant="caption">{formatTime(timeInMinutes)}</Typography>
                        </div>
                        <div className={classes.mediaDetail}>
                            <Icon color="secondary">
                                <Kitchen/>
                            </Icon>
                            <Typography variant="caption">{ingredients.length}</Typography>
                        </div>
                        <div className={classes.mediaDetail}>
                            <Icon color="secondary">
                                <ChatBubbleOutline/>
                            </Icon>
                            <Typography variant="caption">{Math.floor(Math.random() * 50)}</Typography>
                        </div>
                        <div className={classes.mediaDetail}>
                            <Icon color="secondary">
                                <BookmarkBorder/>
                            </Icon>
                            <Typography variant="caption">{Math.floor(Math.random() * 100)}</Typography>
                        </div>
                        <div className={classes.mediaDetail}>
                            <Icon color="secondary">
                                <FavoriteBorder/>
                            </Icon>
                            <Typography variant="caption">{Math.floor(Math.random() * 200)}</Typography>
                        </div>
                        <div className={classes.mediaDetail}>
                            <Icon color="secondary">
                                <Visibility/>
                            </Icon>
                            <Typography variant="caption">{views}</Typography>
                        </div>
                    </div>
                </CardMedia>
                <div style={{display: 'flex', alignItems: 'center', padding: '4px 8px 0'}} onClick={(e) => e.stopPropagation()}>
                    <Button onClick={() => userClick(recipe.user.id)} style={{padding: 0, minWidth: 0, textTransform: 'none'}}>
                        <Typography variant="caption" color="textPrimary" component="p">
                            Recipe by: {recipe.user ? recipe.user.username : "N/A"}
                        </Typography>
                    </Button>
                    <IconButton size="small" onClick={() => setExpanded(!expanded)} style={{marginLeft: 'auto',padding: '0px'}}>
                        <ExpandMore style={{transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s'}}/>
                    </IconButton>
                </div>
            </div>
            <Collapse in={expanded}>
                <div style={{padding: '0px 8px 4px'}}>
                    {about && (
                        <Typography variant="caption" color="textSecondary" component="p" style={{paddingTop: 4}}>
                            {about}
                        </Typography>
                    )}
                    {labels && labels.length > 0 && (
                        <div style={{display: 'flex', flexWrap: 'wrap', gap: 4, paddingTop: 4}}>
                            {labels.map(label => <Chip key={label} label={label} size="small" onClick={() => chipClick(label)} clickable style={{height: 20, fontSize: '0.7rem'}}/>)}
                        </div>
                    )}
                </div>
            </Collapse>
        </Card>
    )
}
